import { Routes } from '@angular/router';
import { CvResumeComponent } from './cv-resume/cv-resume.component';
import { AdminWorkbiesComponent } from './admin-workbies/admin-workbies.component';
import { HelpRequestsComponent } from './help-requests/help-requests.component';
import { WorkbiePayoutsComponent } from './workbie-payouts/workbie-payouts.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { TermsConditionsComponent } from './landing-page/landing-components/terms-conditions/terms-conditions.component';
import { PrivacyComponent } from './landing-page/landing-components/privacy/privacy.component';
import { AboutUsComponent } from './landing-page/landing-components/about-us/about-us.component';
import { LoginComponent } from './admin-login/login.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { AdminCategoriesComponent } from './admin-categories/admin-categories.component';
import { FormBuilderComponent } from './admin-categories/form-builder/form-builder.component';
import { AdminCouponsComponent } from './admin-coupons/admin-coupons.component';
import { AdminFinancesComponent } from './admin-finances/admin-finances.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
    { path: 'd/:id', component: CvResumeComponent },
    { path: 'admin/login', component: LoginComponent },
    {
        path: 'admin',
        component: AdminLayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: 'workbies', component: AdminWorkbiesComponent },
            { path: 'help-requests', component: HelpRequestsComponent },
            { path: 'payouts', component: WorkbiePayoutsComponent },
            { path: 'categories', component: AdminCategoriesComponent },
            { path: 'categories/form/:subcategoryId', component: FormBuilderComponent },
            { path: 'coupons', component: AdminCouponsComponent },
            { path: 'finances', component: AdminFinancesComponent },
            { path: '', redirectTo: 'workbies', pathMatch: 'full' }
        ]
    },
    { path: '', component: LandingPageComponent },
    { path: 'quienes-somos', component: AboutUsComponent },
    { path: 'about-us', redirectTo: 'quienes-somos', pathMatch: 'full' },
    { path: 'terms-conditions', component: TermsConditionsComponent },
    { path: 'privacy', component: PrivacyComponent }
];
